// THE DROP'S KINDS (paperwork-1 D7, A18): what a file dropped on a deal can be, each with one plain line saying what it is,
// so a mis-pick is hard. The server's list is routes/documents.routes.js DROP_KINDS (tests/documents-one-home.test.js
// compares the two). `carrier` kinds are never offered for a file the server says is NDEMNIFLY's own paper (R5); `pick`
// names the second question a kind asks (which ledger row, which holder).
export const DROP_KINDS = Object.freeze([
  { kind: 'policy', label: 'Policy', line: "The carrier's issued policy: the dec page and forms.", carrier: true },
  { kind: 'binder', label: 'Binder', line: "The carrier's binder: proof of cover until the policy arrives.", carrier: true },
  { kind: 'endorsement', label: 'Endorsement', line: "The carrier's change to this policy.", carrier: true, pick: 'transaction' },
  { kind: 'certificate', label: 'Certificate', line: "The carrier's certificate naming a lienholder, loss payee or additional insured.", carrier: true, pick: 'interest' },
  { kind: 'cancellation', label: 'Cancellation confirmation', line: "The carrier's confirmation that the policy is cancelled.", carrier: true, pick: 'transaction' },
  { kind: 'application', label: 'Signed application', line: 'The application the client signed; it is filed with the signed paperwork.' },
  { kind: 'quote', label: 'Quote', line: "A carrier's quote: TRACON reads it and opens the quote review." },
  { kind: 'other', label: 'Something else', line: 'Anything else for this policy, filed as other.' },
]);

// Shown beside the kinds: the bundle is ours and is not a drop kind (A4: Review paperwork files it).
export const BUNDLE_LINE = 'NDEMNIFLY binder: our bundle, made by TRACON, never a carrier document. Review paperwork files it; it is not dropped here.';

// The kinds "Wrong type? Change it" may move a filed document to: every drop kind but the quote (the quote drop parses it, its
// own door). Signed application asks the signing day and files through the application writer (N5, David 2026-11-01).
export const RETYPE_KINDS = Object.freeze(DROP_KINDS.filter((k) => k.kind !== 'quote'));

export function dropKind(kind) {
  return DROP_KINDS.find((k) => k.kind === kind) || null;
}

// A filed row's class, in the drop's words (the class ids the server answers equal the carrier kinds and "other").
export function classLabel(klass) {
  const k = dropKind(klass);
  return k ? k.label : String(klass || 'document').replace(/_/g, ' ');
}

// What a drop filed, in words (the second Chrome pass, round 2: one binder said "Policy documents filed"): the kind when every
// file is one kind, else the general words; no file at all is the policy number alone.
export function filedWords(kinds) {
  const ks = kinds || [];
  if (!ks.length) return 'Policy number saved';
  if (new Set(ks).size !== 1) return 'Policy documents filed';
  const label = ks[0] === 'other' ? 'Document' : classLabel(ks[0]);
  return ks.length === 1 ? `${label} filed` : `${ks.length} ${label.toLowerCase()}s filed`;
}

// A filename may PRESELECT a kind; it never routes without the broker confirming (prompt 173). Certificate is checked
// FIRST ("endorsement certificate" is a certificate); a separator class, not \b, since "_" is a word character in JS.
export function suggestDropKind(name) {
  const n = String(name || '').toLowerCase();
  if (/quote|quotation/.test(n)) return 'quote';
  if (/binder/.test(n)) return 'binder';
  if (/certificate|(^|[^a-z0-9])(coi|cert)([^a-z0-9]|$)/.test(n)) return 'certificate';
  if (/endt|endorse/.test(n)) return 'endorsement';
  if (/cancel/.test(n)) return 'cancellation';
  if (/application/.test(n)) return 'application';
  if (/policy|dec[\s_-]?page/.test(n)) return 'policy';
  return '';
}
